import { useContext, createContext, FC, ReactNode } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import { fetchData, postData } from "../Services/GlobalService";

interface SafetyTickerContextProps {
  confirmPopup: boolean;
  setConfirmPopup: (value: boolean) => void;
  DeleteData : () => void;
  ticketId:string;
  setTicketId:(value:string)=>void;
  allTickets:any;
  setAllTickets:(value:any)=>void;
  loading:boolean;
  setLoading: (value: boolean) => void;
}

const SafetyTickerContext = createContext<SafetyTickerContextProps>(
  {} as SafetyTickerContextProps
);

interface SafetyTickerProviderProps {
  children: ReactNode;
}

const SafetyTickerProvider: FC<SafetyTickerProviderProps> = ({
  children,
}) => {
  const [confirmPopup, setConfirmPopup] = useState<boolean>(false);
  const [ticketId, setTicketId] = useState("");
  const [allTickets, setAllTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const UserId = localStorage.getItem("UserId")?.toString();
  const BaseUrl = "masters/Miscellaneous/SafetyTicker";
  const EndPoint = {
    DeleteTicketData:"DeleteTicketData",
    LoadTicketData:"LoadTicketData",
  };
const PopulateTicketData = async() => {
  setLoading(true);
  try{
    await fetchData(BaseUrl,EndPoint.LoadTicketData,``)
    .then((res)=>{
      setAllTickets(res.Data);
      setLoading(false);
    })
  }catch(ex:any){
    toast.error(ex.response.data.message);
    setLoading(false);
  }
}
  const DeleteData = async() => {
    setLoading(true);
    try{
      let obj = {
        userId: UserId,
        pvC_TICKER_CODE: ticketId
      }
      postData(BaseUrl,EndPoint.DeleteTicketData,JSON.stringify(obj))
      .then((res)=>{
        toast.success(res.message);
        setConfirmPopup(false);
        PopulateTicketData();
        setLoading(false);
      })
    }
    catch(ex:any){
      toast.error(ex.response.data.message);
      setLoading(false);
    }
  }

  return (
    <SafetyTickerContext.Provider
      value={{
        confirmPopup,
        setConfirmPopup,
        DeleteData,
        ticketId, 
        setTicketId,
        allTickets, 
        setAllTickets,
        loading, 
        setLoading
      }}
    >
      {children}
    </SafetyTickerContext.Provider>
  );
};

export const useSafetyTickerContext = () => {
  return useContext(SafetyTickerContext);
};

export { SafetyTickerProvider, SafetyTickerContext };